import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.status === "ok") setUser(data);
    return data;
  };

  const verify2fa = async (payload) => {
    const { data } = await api.post("/auth/login/2fa", payload);
    if (data.status === "ok") setUser(data);
    return data;
  };

  const enrollStart = async (enrollToken) => {
    const { data } = await api.post("/auth/2fa/enroll/start", {}, enrollToken ? { headers: { "X-Enroll-Token": enrollToken } } : undefined);
    return data;
  };

  const enrollVerify = async (code, enrollToken) => {
    const { data } = await api.post("/auth/2fa/enroll/verify", { code }, enrollToken ? { headers: { "X-Enroll-Token": enrollToken } } : undefined);
    if (data.user) setUser(data.user);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(false);
  };

  const toggleFavorite = async (pid) => {
    const { data } = await api.post(`/auth/favorites/${pid}`);
    setUser((u) => (u ? { ...u, favorites: data.favorites } : u));
    return data.favorited;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, verify2fa, enrollStart, enrollVerify, logout, refresh: check, toggleFavorite }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
